import { LS2PAC_CONSTANTS } from "../../../js/main/constants";
import { TLCEXT } from "../../../js/lib/ext/Ext";

import { ApplicationData } from "./ApplicationData";
import { EventQueue } from "../../../js/lib/events/EventQueue";
import { LibraryThing } from "./widget/LibraryThingWidget";
import { ResourceUtils } from "./utils/resourceUtils";
import { LoginClientManager } from "./ClientManagers/LoginClientManager";
import { TLCLogger } from "../../../js/lib/logger";
// import { HarlemShake } from "../ls2kids/harlemShake";
import { TLCAnalyticsManager } from "./managers/TLCAnalyticsManager";
import { CustomerAnalyticsManager } from "./managers/CustomerAnalyticsManager";

import { createRoot } from "react-dom/client";
import * as React from "react";

// These imports all use IIFE to create instances on import
// they should by nature create sideEffects and not be removed by webpack during tree shaking
// the exported value from the IIFE should be cached, so we should not have issues importing multiple times
// generally speaking we should move away from event based managers like these that are not called directly
// toward something more explicit and clear to the developer
// it makes it really difficult to know how many of these managers are actually used at this point and need to be initialized
// At the very least, move the constant for the events listened/fired by the manager
// to a static property of the manager so the imports are required to fire the event
// some of these files may not be used but were part of the original bundle
import { Marc21DisplayClientManager } from "./ClientManagers/Marc21DisplayClientManager";
import { ListsClientManager } from "./ClientManagers/ListsClientManager";
import { ResourceClientManager } from "./ClientManagers/ResourceClientManager";
import { StoredImageClientManager } from "./ClientManagers/storedImageClientManager";
import { LandingPageConfigClientManager } from "./ClientManagers/LandingPageConfigClientManager";
import { AvailabilityFactory } from "../availability/AvailabilityFactory";
import { EResourceCheckoutsClientManager } from "./ClientManagers/EResourceCheckoutsClientManager";

import { RequestsClientManager } from "./ClientManagers/RequestsClientManager";

// jQuery plugin
import { AddCoverArt } from "./utils/addCoverArt";
import { App } from "@tlc/ls2pac/components/App";
import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { TLCEventManager } from "src/main/resources/js/lib/events/EventManager";
import { LocationConfigurationHolder } from "@tlc/ls2pac/components/LocationConfiguration";
import { OBRSettingHolder } from "@tlc/ls2pac/components/OBRSettings";
import { GlobalConfigHolder } from "@tlc/ls2pac/components/GlobalConfig";
import { loadDayJSLocale } from "@tlc/ui/localization/getDayJSLocale";
import { LanguageHolder } from "@tlc/ls2pac/components/Language";
import { SupportedFunctionalityHolder } from "@tlc/ls2pac/components/SupportedFunctionality";
import { StationLocationHolder } from "@tlc/ls2pac/components/StationLocation";

var _gaq = _gaq || [];
export const LS2PacMain = (function ($) {
  $.ajaxSetup({
    headers: {
      "Ls2pac-config-type": "pac",
      "Ls2pac-config-name": window["config"],
    },
  });

  return {
    //this is the initialization point for the app
    start: function () {


      var progressbarElement = $(
        "#" + LS2PAC_CONSTANTS.Ids.loadingProgress
      ).progressbar({ value: 10 });

      // TODO move this data fetching to each appropriate loader that way the error boundary catches any issues
      // as it is, most of these are likely included in loaders already
      EventQueue.createQueue(
        [
          { funcWithCallback:  async (callback) => {
            await LanguageHolder.fetchLanguage().catch(e => {
              console.error("Error fetching language on app start", e);
             });
            return callback();
          }},
          { funcWithCallback: async (callback) => {
            await AccountHolder.fetchAccountData().catch(e => {
              console.error("Error fetching account data on app start", e);
             });
            return callback();
          } },
          { funcWithCallback: async function(callback) {
            await SupportedFunctionalityHolder.get().catch(e => {
              console.error("Error fetching supported functionality on app start", e);
             });
            callback();
          }},
          {
            funcWithCallback: async function(callback) {
              await OBRSettingHolder.getConfig().catch(e => {
                console.error("Error fetching OBR settings on app start", e);
              });
              callback();
            }
          },
          {
            funcWithCallback: async function (callback) {
              await GlobalConfigHolder.fetchGlobalConfig().catch(e => {
                console.error("Error fetching global config on app start", e);
              });
              callback();
            },
          },
          {
            funcWithCallback: async function (callback) {
              await LocationConfigurationHolder.fetchLocationConfiguration().catch(e => {
                console.error("Error fetching location configuration on app start", e);
              });
              callback();
            },
          },
          { funcWithCallback: async function (callback) {
              await StationLocationHolder.get().catch(e => {
                console.error("Error fetching station location on app start", e);
              });
              callback();
            }, },
          {
            funcWithCallback: function (callback) {
              LibraryThing.initConfig(ApplicationData.language, callback);
            },
          },
        ],
        async function () {

          TLCLogger.log("done loading", ApplicationData);
          

          TLCEXT.setBaseData({
            languageUtil: ApplicationData.language,
            resourceUtil: ResourceUtils,
            ls2pacConstants: LS2PAC_CONSTANTS,
            muiContainedButton: "TEMP_muiContainedButton",
            muiTextButton: "TEMP_muiTextButton",
            muiOutlinedButton: "TEMP_muiOutlinedButton",
            muiButtonAsLink: "TEMP_muiButtonAsLink",
          });

          await loadDayJSLocale();// all errors are caught

          $("#" + LS2PAC_CONSTANTS.Ids.mainLoader).fadeOut(300, function () {

            // React App
            var divElement = document.createElement('div');
            divElement.id = 'react-app';

            // Create skip link portal
            var skipLinksContainer = document.createElement('div');
            skipLinksContainer.id = 'skip-link-portal';

            // Insert react app first
            document.body.insertBefore(divElement, document.body.firstChild);

            // Then insert skip links before it
            document.body.insertBefore(skipLinksContainer, document.body.firstChild);

            // render react app
            const root = createRoot(divElement);
            root.render(<App />);
            
          });

          // HarlemShake.doRelative = true;
          // HarlemShake.delay = 1000;
          // HarlemShake.elementsToApply =
          //   "#header_searchInput, form .searchBar, form a.advancedSearch, .searchButton, .page a, ul.nav a";
          // HarlemShake.mainDancerSelector = ".speech a";

          // HarlemShake.doHistory = function () {
          //   location.href = "/#section=home";
          // };

          // HarlemShake.init();
        },
        function (progress, total, current) {
          progressbarElement.progressbar("value", progress);
        }
      );

      /* Fix scaling issues with ipad/iphone */
      if (
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i)
      ) {
        var viewportmeta = document.querySelector('meta[name="viewport"]');
        if (viewportmeta) {
          viewportmeta.content =
            "width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0";
          document.body.addEventListener(
            "gesturestart",
            function () {
              viewportmeta.content =
                "width=device-width, minimum-scale=0.25, maximum-scale=1.6";
            },
            false
          );
        }
      }
    },
  };
})(jQuery);
